<script lang="ts" setup>
import { useConfigStore } from '~/store/useConfigStore'

const store = useConfigStore()
const { footerTeamColumnsMenu } = storeToRefs(store)
</script>

<template>
  <div class="footer-team-menu">
    <Wrapper>
      <div class="footer-team-menu__content">
        <nav
          v-if="footerTeamColumnsMenu"
          class="footer-team-menu__nav"
        >
          <Menu
            :menu="footerTeamColumnsMenu"
            class="footer-team-menu__list"
          />
        </nav>

        <FooterMenuSocial />
      </div>
    </Wrapper>
  </div>
</template>

<style lang="scss" scoped>
.footer-team-menu {
  @apply py-[40px];
  @apply lg:py-[85px];

  &__content {
    @apply w-full flex flex-col;
    @apply md:flex-row md:justify-between;
  }

  &__nav {
    @apply w-full mb-[40px];
    @apply md:mb-0 md:w-auto md:mr-[100px];
    @apply xl:mr-[250px];
  }

  &__list {
    @apply flex flex-wrap gap-y-[30px];
    @apply md:gap-x-[50px];
    @apply lg:gap-x-[100px];
    @apply xl:gap-x-[170px];
  }

  :deep(.column-menu-item__title) {
    @apply text-[18px] text-white font-normal leading-[1] mb-[25px];
  }

  :deep(.column-menu-item__submenu) {
    @apply flex flex-col gap-y-[20px];
  }

  :deep(.menu-item) {
    @apply items-start;
  }

  :deep(.menu-item__top-level) {
    @apply w-1/2;
    @apply md:w-auto;
  }

  :deep(.static-url-menu-item) {
    @apply text-[18px] text-white/60 font-normal leading-[1] transition-colors duration-300;
    @apply hover:text-white;
  }
}
</style>
